///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { StaticContentDTO } from '../../../generated/shared-types.model';
import { ExtendedStaticContent } from './extended-static-content.model';
import { GtthReleaseNotesProductCompatibility } from './release-note-items/release-notes-product-compatibility.model';

export class CompatibilityStaticContent implements ExtendedStaticContent {
    public readonly TITLE_TRANSLATION_PATH = 'global.menu.help.releaseNotes.productCompatibility';
    public readonly TOOLTIP_TRANSLATION_PATH = 'releaseNotes.addProductCompatibility';
    public id: number;
    public type: string;
    public content: GtthReleaseNotesProductCompatibility[];

    constructor(data: StaticContentDTO) {
        this.id = data.id;
        this.type = data.type;
        this.content = data.content.map((item) => new GtthReleaseNotesProductCompatibility(item.version, item.units));
    }

    getPlainObject(): StaticContentDTO {
        return {
            id: this.id,
            type: this.type,
            content: this.content.map((item: GtthReleaseNotesProductCompatibility) => item.getPlainObject())
        };
    }

    getTitleTranslationPath() {
        return this.TITLE_TRANSLATION_PATH;
    }

    getTooltipTranslationPath() {
        return this.TOOLTIP_TRANSLATION_PATH;
    }

    update(item: any): GtthReleaseNotesProductCompatibility {
        return new GtthReleaseNotesProductCompatibility(item?.version, item?.units);
    }
}
